import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useLogin } from '../api/useAuth'
import { getErrMsg } from '../api/client'
import Input from '../components/ui/Input'
import toast from 'react-hot-toast'

export default function Login() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const returnUrl = searchParams.get('returnUrl') || '/'

  const [form, setForm] = useState({ email: '', password: '' })
  const [showPwd, setShowPwd] = useState(false)
  const [errors, setErrors] = useState({})
  const [serverError, setServerError] = useState('')

  const { mutate: login, isPending } = useLogin()

  const validate = () => {
    const e = {}
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) e.email = 'Введите корректный email'
    if (!form.password) e.password = 'Введите пароль'
    return e
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const errs = validate()
    if (Object.keys(errs).length) { setErrors(errs); return }
    setErrors({})
    setServerError('')
    login(form, {
      onSuccess: () => {
          toast.success('Добро пожаловать!')
          const decoded = decodeURIComponent(returnUrl)
          const safeUrl = decoded && decoded.startsWith('/') && !decoded.startsWith('//') ? decoded : '/'
          navigate(safeUrl)
        },
      onError: (err) => setServerError(getErrMsg(err, 'Неверный email или пароль')),
    })
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-sm rounded-2xl p-8 flex flex-col gap-6 bg-surface border border-line">
        <div className="text-center">
          <h1 className="text-2xl font-black">Вход</h1>
          <p className="text-sm mt-1 text-muted">Рады видеть вас снова</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input label="Email" type="email" placeholder="you@example.com"
            value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            error={errors.email} autoComplete="email" />

          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-muted">Пароль</label>
            <div className="relative">
              <input
                type={showPwd ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                autoComplete="current-password"
                className={`w-full px-4 py-2.5 pr-10 rounded-lg text-sm outline-none transition-colors bg-surface2 text-fg
                  ${errors.password ? 'border border-red-500 focus:border-red-500' : 'border border-line focus:border-accent'}`}
              />
              <button type="button" onClick={() => setShowPwd((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted">
                {showPwd ? '🙈' : '👁️'}
              </button>
            </div>
            {errors.password && <span className="text-xs text-red-400">{errors.password}</span>}
          </div>

          {serverError && (
            <div className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm bg-red-400/10 border border-red-400/25 text-red-400">
              <span>⚠</span><span>{serverError}</span>
            </div>
          )}

          <button type="submit" disabled={isPending}
            className="w-full py-3 rounded-xl font-bold text-sm transition-all disabled:opacity-50 bg-accent text-on-accent hover:opacity-90">
            {isPending ? 'Входим...' : 'Войти'}
          </button>
        </form>

        <p className="text-sm text-center text-muted">
          Нет аккаунта?{' '}
          <Link to="/register" className="font-semibold text-accent">Регистрация</Link>
        </p>
        <p className="text-sm text-center -mt-4">
          <Link to="/forgot-password" className="text-muted hover:text-accent transition-colors text-xs">
            Забыли пароль?
          </Link>
        </p>
      </div>
    </div>
  )
}
